import { string } from 'prop-types'
import React from 'react'
import { Route, Navigate } from 'react-router-dom'

export const Redirect = ({ to, path }) => {
  return <Route element={<Navigate to={to} replace />} path={path} />
}

Redirect.propTypes = {
  to: string.isRequired,
  path: string.isRequired,
}
